import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Membres.css';

const Inscription = () => {
  const { inscription } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await inscription(name, email, password);
      setDone(true);
    } catch (err) {
      setError("Impossible de créer le compte : " + err.message);
    }
  };

  if (done) {
    return (
      <div className="membres-container">
        <h2>Demande d'inscription envoyée ! 📩</h2>
        <p style={{ lineHeight: '1.6', marginBottom: '20px' }}>
          Un e-mail de confirmation vient de vous être envoyé. 
          Veuillez <strong>cliquer sur le lien présent dans le message</strong> pour valider votre adresse.
        </p>
        <p style={{ opacity: 0.8, fontSize: '0.9rem', marginBottom: '25px' }}>
          Une fois votre e-mail confirmé, un administrateur validera définitivement votre profil pour vous donner accès à l'Espace Membres.
        </p>
        <button className="membres-btn" onClick={() => navigate('/connexion')}>
          Aller à la page de connexion
        </button>
      </div>
    );
  }

  return (
    <div className="membres-container">
      <h2>Inscription à l'espace membres</h2>
      <form onSubmit={handleSubmit} className="membres-form">
        <input
          type="text"
          placeholder="Nom & Prénom"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Mot de passe (6 caractères min.)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          minLength={6}
          required
        />
        {error && <p className="membres-error">{error}</p>}
        <button type="submit" className="membres-btn">S'inscrire</button>
      </form>
      <p style={{ marginTop: '15px' }}>
        Déjà un compte ? <Link to="/connexion">Se connecter</Link>
      </p>
    </div>
  );
};

export default Inscription;